export async function getTrainingDatasets(token, ids) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/training-datasets/?ids=${ids.join(
        ","
      )}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return {};
  }
}

export async function uploadTrainingDataset(token, accountID, file, fileName) {
  const formData = new FormData();

  formData.append("csv", file);
  formData.append("account", accountID);
  formData.append("original_file_name", fileName);
  formData.append("format", "Closed Opportunities");

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/training-datasets/`,
      {
        method: "POST",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
        body: formData,
      }
    );
    return await response.json();
  } catch (error) {
    return {};
  }
}

export async function deleteTrainingDatasets(token, id) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/training-datasets/`,
      {
        method: "DELETE",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return {};
  }
}
